import React from "react";
import { createTheme } from "@material-ui/core/styles";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "@reach/router";
import { LinkProps } from "@material-ui/core/Link";


// eslint-disable-next-line react/display-name
const LinkBehavior = React.forwardRef<
HTMLAnchorElement,
Omit<RouterLinkProps<unknown>, "to"> &
{ href: RouterLinkProps<unknown>["to"] }
>((props, ref) => {
  const { href, children, ...other } = props;
  // Map href (MUI) -> to (react-router)
  // @ts-ignore
  return <RouterLink ref={ref} to={href} {...other} >{children}</RouterLink>;
});

const navy = "#32445a" as const;
const overridings = {
  name: "Light Theme",
  typography: {
    fontFamily: "\"Open Sans\",\"Helvetica Neue\",Helvetica,Arial,sans-serif;",
  },
  palette: {
    primary: {
      main: "#2eb6c8",
    },
    secondary: {
      main: navy,
    },
    error: {
      main: "#A3030A",
    },
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      } as LinkProps,
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior,
      },
    },
  },
  overrides: {
    MuiTypography: {
      root: {
        color: navy,
      },
    },
    MuiTable: {
      root: {
        minWidth: 450,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
      },
      head: {
        fontWeight: 600,
      },
    },
    MuiTableRow: {
      root: {
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
          "& .MuiTableCell-root": {
            borderBottom: "1px solid rgba(224, 224, 224, 1)",
          },
        },
      },
    },
    MuiDialogTitle: {
      root: {
        margin: 0,
      },
    },
    MuiInputBase: {
      root: {
        backgroundColor: "white",
        "&$disabled": {
          backgroundColor: "rgba(0, 0, 0, 0.03)",
        },
      },
    },
    MuiSelect: {
      select: {
        "&:focus": {
          backgroundColor: "white",
        },
      },
    },
    MuiMenuItem: {
      root: {
        "&$selected": {
          backgroundColor: "rgba(47, 181, 199, 0.2)",
          color: "#32445a",
        },
      },
    },
    MuiListItem: {
      root: {
        "&$selected": {
          backgroundColor: "rgba(47, 181, 199, 0.2)",
          color: "#32445a",
        },
      },
    },
    MuiAutocomplete: {
      inputRoot: {
        backgroundColor: "white",
      },
      // https://github.com/mui-org/material-ui/issues/19692
      option: {
        "&[data-focus=\"true\"]": {
          backgroundColor: "#effafa",
        },
        "&[aria-selected=\"true\"]": {
          backgroundColor: "#effafa",
        },
      },
      tag: {
        flexDirection: "row !important",
        flex: "none !important",
      },
    },
    MuiButton: {
      root: {
        textTransform: "initial" as const,
        fontWeight: 800,
      },
      containedPrimary: {
        color: "white",
        backgroundColor: "#2eb6c8",
        "&$disabled": {
          color: "white",
          backgroundColor: "rgba(46, 182, 200, 0.5)",
        },
      },

    },
    MuiPickersMonthSelection: {
      container: {
        flexDirection: "column",
      },
    },
    MuiDialog: {
      paperWidthSm: {
        maxWidth: "800px",
      },
    },
  },
};

export default createTheme(overridings);
